import React, { useState } from 'react';
import './StateSelector.css';

const StateSelector = ({ onStateSelect }) => {
  const [selectedState, setSelectedState] = useState('');
  const [sortBy, setSortBy] = useState('alphabetical'); // 'alphabetical', 'name'
  const [filterText, setFilterText] = useState('');

  // All Brazilian states in alphabetical order
  const allStates = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
    'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
    'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
  ];

  // State names for better filtering
  const stateNames = {
    'AC': 'Acre',
    'AL': 'Alagoas',
    'AP': 'Amapá',
    'AM': 'Amazonas',
    'BA': 'Bahia',
    'CE': 'Ceará',
    'DF': 'Distrito Federal',
    'ES': 'Espírito Santo',
    'GO': 'Goiás',
    'MA': 'Maranhão',
    'MT': 'Mato Grosso',
    'MS': 'Mato Grosso do Sul',
    'MG': 'Minas Gerais',
    'PA': 'Pará',
    'PB': 'Paraíba',
    'PR': 'Paraná',
    'PE': 'Pernambuco',
    'PI': 'Piauí',
    'RJ': 'Rio de Janeiro',
    'RN': 'Rio Grande do Norte',
    'RS': 'Rio Grande do Sul',
    'RO': 'Rondônia',
    'RR': 'Roraima',
    'SC': 'Santa Catarina',
    'SP': 'São Paulo',
    'SE': 'Sergipe',
    'TO': 'Tocantins'
  };

  const handleStateClick = (estado) => {
    setSelectedState(estado);
    if (onStateSelect) {
      onStateSelect(estado);
    }
  };

  // Filter and sort states
  const getFilteredAndSortedStates = () => {
    // Filter states based on search text
    let filteredStates = allStates.filter(state => {
      const searchLower = filterText.toLowerCase();
      return state.toLowerCase().includes(searchLower) || 
             stateNames[state].toLowerCase().includes(searchLower);
    });

    // Sort states based on selected option
    switch (sortBy) {
      case 'alphabetical':
        // Already in alphabetical order
        break;
      case 'name':
        filteredStates.sort((a, b) => stateNames[a].localeCompare(stateNames[b]));
        break;
      default:
        break;
    }

    return filteredStates;
  };

  const displayStates = getFilteredAndSortedStates();

  return (
    <div className="state-selector-container">
      <h2>Selecione um Estado</h2>
      <p className="subtitle">Clique em um estado para visualizar os dados</p>
      
      <div className="filter-controls">
        <div className="search-box">
          <input
            type="text"
            placeholder="Buscar por sigla ou nome do estado..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            className="search-input"
          />
        </div>
        
        <div className="sort-controls">
          <label htmlFor="sort-select">Ordenar por:</label>
          <select
            id="sort-select"
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="sort-select"
          >
            <option value="alphabetical">Sigla (A-Z)</option>
            <option value="name">Nome do Estado</option>
          </select>
        </div>
      </div>

      <div className="states-info">
        <p>Exibindo {displayStates.length} de {allStates.length} estados</p>
        {selectedState && (
          <p className="selected-state">Selecionado: <strong>{selectedState} - {stateNames[selectedState]}</strong></p>
        )}
      </div>
      
      <div className="states-grid">
        {displayStates.map((estado) => (
          <div 
            key={estado} 
            className={`state-card ${selectedState === estado ? 'selected' : ''}`}
            onClick={() => handleStateClick(estado)}
            title={stateNames[estado]}
          >
            <h2>{estado}</h2>
            <p className="state-name">{stateNames[estado]}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StateSelector;
